module.exports = __webpack_public_path__ + "static/media/account-state.14178229.svg";